module.exports = __webpack_public_path__ + "media/asset/images/1_KV/ITRI_cover_JP-ff37479cd6a3eddf2d2dde8a841f7438.png";